<template>
  <div class="producttypefiletype-list">
    <Toolbar :handle-add="addHandler" v-if="userHasAccess('producttypefiletype_edit')"/>

    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex sm12>
          <h1><v-icon large>mdi-file-document-edit-outline</v-icon>{{$t('qualitycheck.product.producttypefiletypes')}}</h1>
        </v-flex>
        <v-flex lg12>
          <DataFilter :handle-filter="onSendFilter" :handle-reset="resetFilter">
            <ProducttypefiletypeFilterForm
              ref="filterForm"
              :values="filters"
              slot="filter"
            />
          </DataFilter>

          <br />

          <v-data-table
            v-model="selected"
            :headers="headers"
            :items="items"
  :items-per-page.sync="options.itemsPerPage"
:footer-props="footer"
            :loading="isLoading"
            :loading-text="$t('global.loading')"
            :options.sync="options"
            :server-items-length="totalItems"
            class="elevation-1"
            item-key="@id"
            @update:options="onUpdateOptions"
@click:row="showHandler"
@contextmenu:row="showHandlerExt"
          >
          <template slot="item.material" slot-scope="{ item }">
            <strong v-if="item.material" >
              <v-icon color="green">mdi-check-circle</v-icon>
            </strong>
            <span v-else>
              <v-icon color="red">mdi-close-circle</v-icon>
            </span>
          </template>
          <template slot="item.notice" slot-scope="{ item }">
            <strong v-if="item.notice" >
              <v-icon color="green">mdi-check-circle</v-icon>
            </strong>
            <span v-else>
              <v-icon color="red">mdi-close-circle</v-icon>
            </span>
          </template>
          <template slot="item.updateSoft" slot-scope="{ item }">
            <strong v-if="item.updateSoft" >
              <v-icon color="green">mdi-check-circle</v-icon>
            </strong>
            <span v-else>
              <v-icon color="red">mdi-close-circle</v-icon>
            </span>
          </template>
          <template slot="item.factoryReset" slot-scope="{ item }">
            <strong v-if="item.factoryReset" >
              <v-icon color="green">mdi-check-circle</v-icon>
            </strong>
            <span v-else>
              <v-icon color="red">mdi-close-circle</v-icon>
            </span>
          </template>
            <ActionCell
              slot="item.action"
              slot-scope="props"
              :handle-show="() => showHandler(props.item)"
            ></ActionCell>
          </v-data-table>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import ListMixin from '../../mixins/ListMixin';
import ActionCell from '../../components/ActionCell';
import ProducttypefiletypeFilterForm from '../../components/producttypefiletype/Filter';
import DataFilter from '../../components/DataFilter';
import Toolbar from '../../components/Toolbar';
import AccessMixin from '../../mixins/AccessMixin';

export default {
  name: 'ProducttypefiletypeList',
  servicePrefix: 'Producttypefiletype',
  mixins: [ListMixin,AccessMixin],
  components: {
    Toolbar,
    ActionCell,
    ProducttypefiletypeFilterForm,
    DataFilter
  },
  data() {
    return {
      headers: [
        { text: this.$t('global.name'), value: 'name' },
        { text: this.$t('global.namefr'), value: 'namefr' },
        { text: this.$t('qualitycheck.product.material'), value: 'material' },
        { text: this.$t('qualitycheck.product.notice'), value: 'notice' },
        { text: this.$t('qualitycheck.product.updatesoft'), value: 'updateSoft' },
        { text: this.$t('qualitycheck.product.factoryreset'), value: 'factoryReset' },
        {
          text: this.$t('global.actions'),
          value: 'action',
          sortable: false
        }
      ],
      selected: [],
      footer: {
        'itemsPerPageText': "",
      },

    };
  },
  computed: {
    ...mapGetters('producttypefiletype', {
      items: 'list'
    }),
    ...mapFields('producttypefiletype', {
      deletedItem: 'deleted',
      error: 'error',
      isLoading: 'isLoading',
      resetList: 'resetList',
      totalItems: 'totalItems',
      view: 'view'
    })
  },
  methods: {
    ...mapActions('producttypefiletype', {
      getPage: 'fetchAll',
      deleteItem: 'del'
    })
  }
};
</script>
